import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';
import close from '../../assets/icons/close.svg';
import checked from '../../assets/icons/checked.svg';
import login from '../../assets/icons/login.svg';
import lightning from '../../assets/icons/lightning.svg';
import transfer from '../../assets/icons/transfer.svg';
import play from '../../assets/icons/play.svg';
import noPremiumDiamond from '../../assets/icons/no-premium-diamond.svg';
import premiumDiamond from '../../assets/icons/premium-diamond.svg';
import bundleAdd from '../../assets/icons/bundle-add.svg';
import percent from '../../assets/icons/percent.svg';
import styles from './Icon.css';

const cx = classnames.bind(styles);

const ICONS = {
    close,
    checked,
    login,
    lightning,
    transfer,
    play,
    noPremiumDiamond,
    premiumDiamond,
    bundleAdd,
    percent
};

function Icon({type, style, onClick, className, color}) {
    const Svg = ICONS[type];
    const iconClasses = cx({
        icon: true,
        [className]: Boolean(className),
        clicked: onClick,
        [color]: Boolean(color)
    });

    const handleClick = e => {
        if (onClick) {
            onClick(e);
        }
    };

    if (!Svg) {
        return null;
    };

    return (
        <i className={iconClasses} style={style} onClick={handleClick}>
            <Svg />
        </i>
    );
}

Icon.propTypes = {
    type: PropTypes.string.isRequired,
    onClick: PropTypes.func,
    style: PropTypes.object,
    className: PropTypes.string,
    color: PropTypes.string
};

Icon.defaultProps = {
    onClick: null,
    style: {},
    className: '',
    color: ''
};

export default Icon;
